var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/missing_indicator.tsx";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Card, CardBody, Stack, Text } from './ui';
const MissingIndicator = ({
  nested = false
}) => /*#__PURE__*/React.createElement(Card, {
  variant: nested ? undefined : 'rounded',
  size: "lg",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement(CardBody, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 12,
    columnNumber: 5
  }
}, /*#__PURE__*/React.createElement(Stack, {
  space: 2,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 13,
    columnNumber: 7
  }
}, /*#__PURE__*/React.createElement(Text, {
  weight: "medium",
  align: "center",
  size: "lg",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 14,
    columnNumber: 9
  }
}, /*#__PURE__*/React.createElement(FormattedMessage, {
  id: "missing_indicator.label",
  tagName: "strong",
  defaultMessage: "Not found",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 15,
    columnNumber: 11
  }
})), /*#__PURE__*/React.createElement(Text, {
  theme: "muted",
  align: "center",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 18,
    columnNumber: 9
  }
}, /*#__PURE__*/React.createElement(FormattedMessage, {
  id: "missing_indicator.sublabel",
  defaultMessage: "This resource could not be found",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 19,
    columnNumber: 11
  }
})))));
export default MissingIndicator;